import { createStyles, makeUiStyles } from "../styles/styles";
import { TitleStylePropsModel } from "./tools/Title.model";
import { StylesIndexInjections } from "common-react";

export default makeUiStyles(() => createStyles({
    title: {
      textAlign: ({ align }: TitleStylePropsModel) => align,
    },
    description: {
      display: 'block',
      marginTop: 8,
      textAlign: ({ align }: TitleStylePropsModel) => align,
    }
  }), { name: 'Title', index: StylesIndexInjections.UI_MOLECULES });
